import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom'

const Guides = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <div className="bg-white">
          <div className="relative bg-gray-900">
            <div className="absolute inset-0">
              <img
                className="w-full h-full object-cover opacity-30"
                src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
                alt="Guides"
              />
            </div>
            <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
              <div className="text-center">
                <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
                  <span className="block">Marketing Guides & Resources</span>
                </h1>
                <p className="mt-6 max-w-3xl mx-auto text-xl text-gray-100">
                  Expert insights to help you master digital marketing strategies.
                </p>
              </div>
            </div>
          </div>
          <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-3">
              {/* Guide 1 */}
              <div className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="flex-shrink-0">
                  <img className="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="SEO Guide" />
                </div>
                <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-primary">
                      SEO
                    </p>
                    <Link to="/guides/seo-playbook" className="block mt-2">
                      <h3 className="text-xl font-semibold text-gray-900">
                        The Complete SEO Playbook for 2023
                      </h3>
                      <p className="mt-3 text-base text-gray-500">
                        Master technical SEO, content strategy, and link building with our comprehensive guide.
                      </p>
                    </Link>
                  </div>
                  <div className="mt-6 flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="flex space-x-1 text-sm text-gray-500">
                        <span>25 min read</span>
                      </div>
                    </div>
                    <div className="text-sm font-medium text-primary hover:text-primary-700">
                      <Link to="/guides/seo-playbook">
                        Read guide →
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* Guide 2 */}
              <div className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="flex-shrink-0">
                  <img className="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Facebook Ads Guide" />
                </div>
                <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-primary">
                      Paid Advertising
                    </p>
                    <Link to="/guides/facebook-ads" className="block mt-2">
                      <h3 className="text-xl font-semibold text-gray-900">
                        Facebook Ads Optimization Handbook
                      </h3>
                      <p className="mt-3 text-base text-gray-500">
                        Advanced strategies to lower your CPA and maximize ROAS on Facebook and Instagram.
                      </p>
                    </Link>
                  </div>
                  <div className="mt-6 flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="flex space-x-1 text-sm text-gray-500">
                        <span>18 min read</span>
                      </div>
                    </div>
                    <div className="text-sm font-medium text-primary hover:text-primary-700">
                      <Link to="/guides/facebook-ads">
                        Read guide →
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* Guide 3 */}
              <div className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="flex-shrink-0">
                  <img className="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Email Marketing Guide" />
                </div>
                <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-primary">
                      Email Marketing
                    </p>
                    <Link to="/guides/email-conversion" className="block mt-2">
                      <h3 className="text-xl font-semibold text-gray-900">
                        Email Conversion Blueprint
                      </h3>
                      <p className="mt-3 text-base text-gray-500">
                        Transform your email campaigns with our proven framework for higher open and click-through rates.
                      </p>
                    </Link>
                  </div>
                  <div className="mt-6 flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="flex space-x-1 text-sm text-gray-500">
                        <span>15 min read</span>
                      </div>
                    </div>
                    <div className="text-sm font-medium text-primary hover:text-primary-700">
                      <Link to="/guides/email-conversion">
                        Read guide →
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* Guide 4 */}
              <div className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="flex-shrink-0">
                  <img className="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Content Strategy Guide" />
                </div>
                <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-primary">
                      Content Strategy
                    </p>
                    <Link to="/guides/content-framework" className="block mt-2">
                      <h3 className="text-xl font-semibold text-gray-900">
                        Content Marketing Framework
                      </h3>
                      <p className="mt-3 text-base text-gray-500">
                        Our step-by-step system for creating content that ranks and converts.
                      </p>
                    </Link>
                  </div>
                  <div className="mt-6 flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="flex space-x-1 text-sm text-gray-500">
                        <span>22 min read</span>
                      </div>
                    </div>
                    <div className="text-sm font-medium text-primary hover:text-primary-700">
                      <Link to="/guides/content-framework">
                        Read guide →
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* Guide 5 */}
              <div className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="flex-shrink-0">
                  <img className="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Social Media Guide" />
                </div>
                <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-primary">
                      Social Media
                    </p>
                    <Link to="/guides/social-media" className="block mt-2">
                      <h3 className="text-xl font-semibold text-gray-900">
                        Social Media Growth Playbook
                      </h3>
                      <p className="mt-3 text-base text-gray-500">
                        Proven tactics to grow your audience and engagement across all platforms.
                      </p>
                    </Link>
                  </div>
                  <div className="mt-6 flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="flex space-x-1 text-sm text-gray-500">
                        <span>20 min read</span>
                      </div>
                    </div>
                    <div className="text-sm font-medium text-primary hover:text-primary-700">
                      <Link to="/guides/social-media">
                        Read guide →
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* Guide 6 */}
              <div className="flex flex-col rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="flex-shrink-0">
                  <img className="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1588072432836-e10032774350?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Analytics Guide" />
                </div>
                <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-primary">
                      Data & Analytics
                    </p>
                    <Link to="/guides/marketing-analytics" className="block mt-2">
                      <h3 className="text-xl font-semibold text-gray-900">
                        Marketing Analytics Mastery
                      </h3>
                      <p className="mt-3 text-base text-gray-500">
                        How to measure what matters and optimize your marketing performance.
                      </p>
                    </Link>
                  </div>
                  <div className="mt-6 flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="flex space-x-1 text-sm text-gray-500">
                        <span>30 min read</span>
                      </div>
                    </div>
                    <div className="text-sm font-medium text-primary hover:text-primary-700">
                      <Link to="/guides/marketing-analytics">
                        Read guide →
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-16 text-center">
              <div className="bg-primary-50 rounded-lg p-8 inline-block">
                <h3 className="text-lg font-medium text-gray-900 mb-4">
                  Want more in-depth resources?
                </h3>
                <Link
                  to="/contact"
                  className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700"
                >
                  Request Custom Guides
                  <svg className="ml-3 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Guides